import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { __, sprintf } from '@wordpress/i18n';

export default function GoogleMapMarker({ servicePoint, onSelect, onToggleInfoWindow, isInfoWindowOpen, iconUrl }) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <AdvancedMarker
      key={servicePoint.id}
      position={{ lat: servicePoint.latitude, lng: servicePoint.longitude }}
      onClick={() => onToggleInfoWindow(!isInfoWindowOpen)}
      ref={markerRef}
    >
      <img src={iconUrl} width={'48px'} height={'48px'} alt={''} />

      {isInfoWindowOpen ? (
        <InfoWindow anchor={marker} maxWidth={300} minWidth={200} onCloseClick={() => onToggleInfoWindow(false)}>
          <div key={servicePoint.id} className={'shipmondo-modal-map_info-window'}>
            <div className={'header'}>
              <span className={'name'}>{servicePoint.name}</span>
            </div>

            <div className={'location'}>
              <div className={'address_info'}>
                {sprintf(
                  // translators: %1$s: Address, %2$s: Zip Code, %3$s: City
                  __('%1$s, %2$s %3$s', 'shipmondo-for-woocommerce'),
                  servicePoint.address,
                  servicePoint.zipcode,
                  servicePoint.city
                )}
              </div>

              <div className={'distance'}>
                {parseFloat((servicePoint.distance / 1000).toFixed(2))} {__('km', 'shipmondo-for-woocommerce')}
              </div>
            </div>

            <button className={'button'} onClick={() => onSelect(servicePoint)}>
              {__('Select', 'shipmondo-for-woocommerce')}
            </button>
          </div>
        </InfoWindow>
      ) : null}
    </AdvancedMarker>
  );
}
